import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import { PrepareEnvelopeDocumentInputData } from "./contactFacade";

class ContactService {
  DoGetContactEnvelopeDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareEnvelopeDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Envelope/GetContactEnvelopeDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetContactEnvelopeDocumentPublicLink(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareEnvelopeDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Envelope/GetContactEnvelopeDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ContactService();
